export const languages = {
  C: "chinese",
  J: "japanese",
  K: "korean",
}
